import React from "react";

const STEPS = ["Cart", "Checkout", "Complete"];

/** Cart → Checkout → Complete progress shown above the cart and checkout pages. */
const CheckoutSteps = ({ current }) => (
  <ol className="bm-steps" aria-label="Checkout progress">
    {STEPS.map((label, index) => {
      const state =
        index < current ? "is-done" : index === current ? "is-active" : "";
      return (
        <React.Fragment key={label}>
          {index > 0 && <li className="bm-step__bar" aria-hidden="true" />}
          <li
            className={`bm-step ${state}`}
            aria-current={index === current ? "step" : undefined}
          >
            <span className="bm-step__dot">
              {index < current ? <i className="ph-bold ph-check" /> : index + 1}
            </span>
            <span className="bm-step__text">{label}</span>
          </li>
        </React.Fragment>
      );
    })}
  </ol>
);

export default CheckoutSteps;
